import * as React from "react";
const SvgEnvelope = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentcolor", d: "M23.333 4.667H4.667A2.33 2.33 0 0 0 2.345 7l-.012 14a2.34 2.34 0 0 0 2.334 2.333h18.666A2.34 2.34 0 0 0 25.667 21V7a2.34 2.34 0 0 0-2.334-2.333m0 4.666L14 15.166 4.667 9.333V7L14 12.833 23.333 7z" }));
export default SvgEnvelope;
